module.exports = __webpack_public_path__ + "static/media/ant-design_star-filled.bbc6efe8.svg";